import type { HomeContent } from "@loot-os/design-system/templates/home/homeContent";
import { useBannersContent } from "./content/banners.js";
import { useHomeBattlesContent } from "./content/battles.js";
import { useFaqContent } from "./content/faq.js";
import { useFeaturedBoxesContent } from "./content/featuredBoxes.js";
import { useHomeForgeContent } from "./content/forge.js";
import { useHeroContent } from "./content/hero.js";
import { usePromoCardsContent } from "./content/promoCards.js";
import { useRecentOpensContent } from "./content/recentOpens.js";

/** Every home section's content, the same under every template. */
export function useHomeContent(): HomeContent {
  const banners = useBannersContent();
  const hero = useHeroContent();
  return {
    // The hero shows the store's banners while any are live, else its own words.
    hero: banners ? { ...hero, banners } : hero,
    promoCards: usePromoCardsContent(),
    recentOpens: useRecentOpensContent(),
    featuredBoxes: useFeaturedBoxesContent(),
    faq: useFaqContent(),
    battles: useHomeBattlesContent(),
    forge: useHomeForgeContent(),
  };
}
